import { Box, Typography } from "@mui/material";
import ContenidoTableRow from "./ContenidoTableRow";

const TABLE_HEADERS = ["Titulo", "Categoria", "Estado", "Actualizado", "Autor", "Acciones"];

export default function ContenidoTable({
  rows,
  loading,
  onEdit,
  onScope,
  onResults,
  onArchive,
  onDelete,
}) {
  return (
    <Box sx={{ bgcolor: "white", borderRadius: "24px", p: 2, boxShadow: "0 4px 12px rgba(0,0,0,0.05)" }}>
      <Box sx={{ display: "flex", bgcolor: "neutral.300", borderRadius: "16px", px: 2, py: 1 }}>
        {TABLE_HEADERS.map((head) => (
          <Typography
            key={head}
            sx={{
              flex: head === "Titulo" ? 2.4 : 1,
              fontSize: 13.5,
              fontWeight: 800,
              color: "primary.900",
            }}
          >
            {head}
          </Typography>
        ))}
      </Box>

      <Box sx={{ mt: 1, minHeight: 120 }}>
        {rows.map((row) => (
          <ContenidoTableRow
            key={row.rowKey || `${row.itemType || "CONTENT"}-${row.id}`}
            row={row}
            onEdit={onEdit}
            onScope={onScope}
            onResults={onResults}
            onArchive={onArchive}
            onDelete={onDelete}
          />
        ))}

        {loading && rows.length === 0 && (
          <Box sx={{ px: 2, py: 2 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: "neutral.700" }}>
              Cargando contenidos...
            </Typography>
          </Box>
        )}

        {!loading && rows.length === 0 && (
          <Box sx={{ px: 2, py: 2 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: "neutral.700" }}>
              No hay resultados con esos filtros.
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}